import {resolvePath} from '@/utils/channel';
import {Link} from 'react-router-dom';
import {RouterLinkProps} from './type';
import {resendWebUvLogIfSamePath} from '@/utils/logger/event';

/**
 * 사용법:
 * <RouterLink name={ROUTE.CHANNEL.SERVICE.POST.POST_VIEW} params={{ streamerId: 'abc', postNumber: 123 }}>
 *   게시글 보기
 * </RouterLink>
 */
export const RouterLink = ({name, params = {}, ...rest}: RouterLinkProps) => {
  const to = resolvePath(name, params);

  return (
    <Link
      to={to}
      {...rest}
      onClick={(event) => {
        resendWebUvLogIfSamePath(to);
        rest.onClick?.(event);
      }}
    />
  );
};
